export const getVariableColor = (color: string | undefined, root?: boolean) => {
  if (!color) return;
  const container = root
    ? document.body
    : document.querySelector(".chart__wrapper") || document.body;
  const styles = getComputedStyle(container, null);
  if (!color.includes("var")) return color;
  const varColorValue = color.substring(
    color.lastIndexOf("(") + 1,
    color.lastIndexOf(")"),
  );
  return styles.getPropertyValue(varColorValue).trim();
};
